import { ActionReducer, Action } from '@ngrx/store';
import { LoadingStatusInitState } from '../models/loading-status.interface';

export const STORE_LOADED = 'STORE_LOADED';
export const COPY_LOADED = 'COPY_LOADED';
export const AIRPORT_COPY_LOADED = 'AIRPORT_COPY_LOADED';
export const RULES_COPY_LOADED = 'RULES_COPY_LOADED';
export const CURRENT_BOOKING_LOADED = 'CURRENT_BOOKING_LOADED';
export const FLIGHT_LOADED = 'FLIGHT_LOADED';
export const USER_LOADED = 'USER_LOADED';
export const PRICE_LOADED = 'PRICE_LOADED';
export const PARTNER_LOADED = 'PARTNER_LOADED';
export const AIRPORTS_LOADED = 'AIRPORTS_LOADED';

export interface ActionWithPayloadInterface extends Action {
  payload: any;
}

const initState: LoadingStatusInitState = {
  storeLoaded: false,
  copyLoaded: false,
  partnerLoaded: false,
  bookingState: false,
  currentBookingLoaded: false,
  userLoaded: false,
  priceLoaded: false,
  flightLoaded: false,
  airportLocationsLoaded: false,
  airportCopyLoaded: false,
  rulesCopyLoaded: false
};

export function loadedStatusReducer (state: LoadingStatusInitState = initState, action: ActionWithPayloadInterface) {

  switch (action.type) {
    case STORE_LOADED:
      return Object.assign({}, state, { storeLoaded: action.payload });

    case RULES_COPY_LOADED:
        return Object.assign({}, state, { rulesCopyLoaded: action.payload });

    case AIRPORT_COPY_LOADED:
        return Object.assign({}, state, { airportCopyLoaded: action.payload });

    case COPY_LOADED:
      return Object.assign({}, state, { copyLoaded: action.payload });

    case CURRENT_BOOKING_LOADED:
      return Object.assign({}, state, { currentBookingLoaded: action.payload });

    case FLIGHT_LOADED:
      return Object.assign({}, state, { flightLoaded: action.payload });

    case PRICE_LOADED:
      return Object.assign({}, state, { priceLoaded: action.payload });

    case USER_LOADED:
      return Object.assign({}, state, { userLoaded: action.payload });

    case PARTNER_LOADED:
      return Object.assign({}, state, { partnerLoaded: action.payload });

    case AIRPORTS_LOADED:
      return Object.assign({}, state, { airportLocationsLoaded: action.payload });


    default:
      return state;
  }

}
